import i18n from '@/i18n';
import { SUPPORTED_LOCALES, isSupported, persistLocale } from '@/i18n/locales';
import { locale as localeConstants } from '@/store/constants';

const { SET_LOCALE } = localeConstants.mutations;

const initialState = {
  current: i18n.locale,
};

// getters
const getters = {
  locale: (state) => state.current,
  availableLocales: () => SUPPORTED_LOCALES,
};

// actions
const actions = {
  setLocale({ commit }, code) {
    if (!isSupported(code)) {
      return;
    }
    persistLocale(code);
    commit(SET_LOCALE, code);
  },
};

// mutations
// Applying the locale is done by the watcher in main.js; the store stays free
// of side effects because Vuex runs in strict mode during development.
/* eslint-disable no-param-reassign */
const mutations = {
  [SET_LOCALE](state, code) {
    state.current = code;
  },
};
/* eslint-enable no-param-reassign */

export default {
  state: initialState,
  getters,
  actions,
  mutations,
};
